<template>
  <div>
    <PageHeader title="مدیریت همکاران ما" :items="pageHeaderItems" />
    <div class="card">
      <div class="d-flex">
        <div class="w-100 ms-2">
          <div class="inner__style mt-3">
            <input style="display: none" type="file" accept="image/*" @change="onFileSelected" ref="fileInputLogo" />
            <div
              v-if="model.images.length === 0"
              class="upload-photo-icon d-flex mx-auto justify-content-center align-items-center"
              @click="(event) => (model.images.length === 2 ? event.preventDefault() : $refs.fileInputLogo.click())"
            >
              <div>
                <i :class="['fas fa-cloud-upload-alt __icon', { 'fas fa-spinner fa-spin': imagesLoading }]"></i>
                <div class="upload-text-size">لوگوی مورد نظر را انتحاب نمایید</div>
              </div>
            </div>
            <div v-else class="grand-parent">
              <div class="uploaded-photo-main">
                <div v-for="(image, index) in model.images" :key="index" class="uploaded-photo">
                  <div class="remove-icon" @click="removeCustomImage({ index, image })">
                    <i class="fa fa-times"></i>
                  </div>
                  <img class="previewImage" :src="image" />
                </div>
                <div v-if="model.images.length" @click="() => $refs.fileInputLogo.click()" class="uploaded-photo addNewImageIconContainer">
                  <i :class="['fa fa-plus', { 'fas fa-spinner fa-spin': imagesLoading }]"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="my-3 px-4">
        <BaseText v-model="model.title" title="عنوان " placeholder="عنوان " labelClass="labelClass" :maxlength="2000" />
      </div>
    </div>
    <Toast :title="message" :error="error" :showToast="showToast" />
    <div class="card p-3 d-flex flex-row justify-content-end">
      <b-button @click="$router.go(-1)">انصراف</b-button>
      <b-button variant="primary ms-2 px-5" @click="onSubmit">ثبت</b-button>
    </div>
  </div>
</template>
<script>
import fileMannager from '../../../services/file'
import PageHeader from '../../../components/layoutComponents/page-header.vue'
import Toast from '../../../components/common/Toast.vue'
import skillUpBannerProvider from '../../../services/skillUp/banner'
import BaseText from '../../../components/common/form/formModules/BaseText.vue'

export default {
  components: { PageHeader, Toast, BaseText },
  data() {
    return {
      model: {
        images: [],
        title: '',
      },
      imagesLoading: false,
      loading: false,
      error: false,
      showToast: false,
      message: '',
      pageHeaderItems: [
        { text: 'داشبورد', href: '/' },
        { text: 'مدیریت همکاران ما', active: true },
      ],
    }
  },
  mounted() {
    this.fetchPartners()
  },
  methods: {
    async fetchPartners() {
      const req = await skillUpBannerProvider.getPartnership(this.$route.params.detail)
      this.model = req.data.data.output
      if (this.model.images[0] === '') {
        this.model.images = []
      }
    },
    async onSubmit() {
      this.showToast = false
      this.loading = true
      try {
        await skillUpBannerProvider.changePartnerShip({ ...this.model })
        this.message = 'اطلاعات با موفقیت ثبت شد.'
        this.showToast = true
        this.loading = false
      } catch (error) {
        this.message = 'خطایی رخ داده، لطفا مجددا تلاش کنید.'
        this.showToast = false
        this.loading = false
      }
    },
    onFileSelected(event) {
      const file = event.target.files[0]
      const reader = new FileReader()

      reader.onload = async (e) => {
        const img = new Image()
        img.src = e.target.result
        this.imagesLoading = true
        const req = await fileMannager.addImage({
          base64image: e.target.result,
        })
        this.model.images.push(req.data.data.downloadUrl)
        this.imagesLoading = false
      }

      reader.readAsDataURL(file)
    },
    removeCustomImage(payload) {
      const find = this.model.images.find((item) => item === payload.image)
      if (find) this.model.images.splice(payload.index, 1)
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .labelClass {
  min-width: 100px !important;
}
.image {
  border-radius: 100%;
  width: 200px;
  height: 200px;
  margin: auto;
}

.upload_video {
  height: 281px;
  width: 100%;
  border: 2px dashed #ced4da;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 25px;
  background-color: white;
}

.video {
  width: 100%;
  height: 122px;
  border-radius: 8px;
  // margin: 20px 20px 0 20px;
}

.pro {
  width: 210px;
}

.progress-b {
  margin: 15px auto;
  direction: ltr;
  width: 85%;
  position: relative;
  left: -10px;
}

.percent {
  width: 100%;
  font-size: 12px;
  display: inline-block;
  margin-left: 20px;
  margin-right: 20px;
  position: relative;
  top: -28px;
  right: -10px;
}

.upload_text {
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
  color: #495057;
}

.second_upload_text {
  font-size: 15px;
  text-align: center;
  margin-top: 10px;
  color: rgba(153, 150, 150, 1);
}

.close_icon {
  position: absolute;
  top: 2px;
  left: 15px;
  font-size: 20px;
  color: grey;
  cursor: pointer;
}

.part {
  display: inline-flex;
  width: 50%;
  strong {
    margin-left: 10px;
    min-width: 50px;
    display: flex;
    align-items: center;
  }
}

.tags {
  ::v-deep .badge-secondary {
    background: #dde3ff !important;
    font-size: 14px !important;
    color: #556be6 !important;
    margin: 2px;
    button {
      color: #556be6;
      background: #dde3ff;
    }
  }
}

.inner__style {
  background-color: white;
  padding: 23px;
}

.uploaded-photo-main {
  display: flex;
  flex-wrap: wrap;
}
.uploaded-photo {
  height: 120px;
  width: 150px;
  position: relative;
  margin-left: 10px;
  margin-bottom: 10px;
  img {
    width: 100%;
    height: 100%;
  }
}
.uploaded-video {
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
}
.remove-icon {
  position: absolute;
  top: 5px;
  left: 5px;
  background-color: gray;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  z-index: 1;
  justify-content: center;
  cursor: pointer;
  i {
    color: white;
  }
}
.upload-text-size {
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
  color: #495057;
}
.icon-size {
  font-size: 45px;
  text-align: center;
  display: block;
  color: #74788d;
}

.upload-photo-icon {
  height: 250px;
  width: 100%;
  border: 2px dashed #ced4da;
  border-radius: 8px;
  cursor: pointer;
}
.grand-parent {
  padding: 20px;
  border: 2px dashed #ced4da;
  justify-content: right;
  display: flex;
  align-items: right;
  position: relative;
}
.activeImageClass {
  border: 3px solid #556ee6;
  border-radius: 5px;
}
.remove-field-link {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  cursor: pointer;
  i {
    color: #ff4861;
  }
}
.previewImage {
  border-radius: 4px;
}
.previewVideo {
  border-radius: 4px;
  width: 100%;
}

.checkbox-margin {
  margin-right: 8px;
}

.__icon {
  display: block;
  color: #74788d;
  font-size: 45px;
  text-align: center;
}
</style>
